import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
    state: {
        cartitems: [], // товары корзины
        cartcount: 0,   // число товаров в корзине
        cartsumm: 0,    // сумма корзины
        pc_discount: 0, // признак применения промокода
        pc_code: '',    // введенный промокод
        change_cart: false, // признак изменения корзины
    },
    mutations,
    actions,
    getters
}
